import { init } from "commandbar"
import Analytics from "utils/analytics"

init("068e939c")
window.CommandBar.boot(window?.app?.user?.id?.toString())

// Most of the route/URL handling for Commandbar actions is done in the Commandbar editor at https://app.commandbar.com/editor/pages
// If you need to update the URL for an action (ie. Find Sequence, Go To Products), you can do so there.
// Commandbar supports callback functions for some actions such as the one below for getBroadcastRoute, but it doesn't currently support callbacks for all actions.

const fetchCampaigns = async () => {
  const response = await fetch("/commandbar/broadcasts")
  return await response.json()
}

const fetchSequences = async () => {
  const response = await fetch("/commandbar/sequences")
  return await response.json()
}

const fetchAutomations = async () => {
  const response = await fetch("/commandbar/automations")
  return await response.json()
}

const fetchTags = async () => {
  const response = await fetch("/commandbar/tags")
  return await response.json()
}

const fetchSegments = async () => {
  const response = await fetch("/commandbar/segments")
  return await response.json()
}

const onSearch = query => {
  if (!query.includes("@")) return []

  return fetch(`/commandbar/subscribers?search=${query}`).then(response =>
    response.json()
  )
}

window.CommandBar.addContext("broadcasts", [])
window.CommandBar.addContext("broadcasts", fetchCampaigns)

window.CommandBar.addContext("sequences", [])
window.CommandBar.addContext("sequences", fetchSequences)

window.CommandBar.addContext("automations", [])
window.CommandBar.addContext("automations", fetchAutomations)

window.CommandBar.addContext("tags", [])
window.CommandBar.addContext("tags", fetchTags)

window.CommandBar.addContext("segments", [])
window.CommandBar.addContext("segments", fetchSegments)

window.CommandBar.addContext("subscribers", [], {
  searchOptions: {
    searchFunction: onSearch
  }
})

window.CommandBar.addEventHandler((name, data) => {
  Analytics.event(`quickfind_${name}`, data)
})

function getBroadcastRoute({ broadcast }) {
  if (broadcast.status === "draft") {
    window.location = `/campaigns/${broadcast.id}/draft`
  } else {
    window.location = `/publications/${broadcast.publicationId}/reports/overview`
  }
}

window.CommandBar.addCallback("broadcasts", args => {
  getBroadcastRoute(args)
})
